var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isElectron)?_c('Header'):_vm._e(),(!_vm.$route.meta.allScreen)?_c('container',[_c('keep-alive',[(_vm.$route.meta.auth)?_c('router-view'):_vm._e()],1),(!_vm.$route.meta.auth)?_c('router-view'):_vm._e()],1):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }